import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ReceiptHeaderCreate,
    ReceiptHeaderDto,
    ReceiptHeaderRead,
    ReceiptHeaderSearchParams,
} from '../../entities/receipt-header.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ReceiptHeaderMetadataMap } from './receipt-header.mapping-profile';

@Injectable()
export class ReceiptHeaderMapper extends AbstractEntityMapper<
    ReceiptHeaderRead,
    ReceiptHeaderCreate,
    ReceiptHeaderDto,
    ReceiptHeaderSearchParams
> {
    constructor() {
        super(
            ReceiptHeaderDto,
            PlatformWmsMapper,
            ReceiptHeaderMetadataMap.symbols
        );
    }
}
